module.exports = __webpack_public_path__ + "static/media/comparison-active-icon.a0671f6e.svg";